import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration for Wado Kai Mobile Auth
const firebaseConfig = {
    apiKey: "AIzaSyBOw7ciwMumwWMhmvjVebheTgDRBohcKzk",
    authDomain: "wadokaimobileauth.firebaseapp.com",
    databaseURL: "https://wadokaimobileauth.firebaseio.com",
    projectId: "wadokaimobileauth",
    storageBucket: "wadokaimobileauth.firebasestorage.app",
    messagingSenderId: "378604781528",
    appId: "1:378604781528:web:08bb432ae96c989574bcad",
    measurementId: "G-2ZM3KKEMDM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app; 